import { actions as PageSyncActions } from './pageSlice';

export const PageActions = {
  ...PageSyncActions,
};
